import React from 'react'

import { Template } from '@store/constants'

interface Props {
  template: Template
}

function ThreeDSkeleton({ template }: Props) {
  return (
    <>
      {template === Template.Default && (
        <div className="h-screen">
          <div className="flex h-full w-full items-center justify-center p-5">
            <div className="h-28 w-6/12 rounded-lg bg-slate-700/30 drop-shadow-lg">
              <div className="shimmer-container relative h-full opacity-50"></div>
            </div>
          </div>
        </div>
      )}

      {template === Template.V2 && (
        <div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-secondaryColour">
          <div className="skeleton"></div>
        </div>
      )}
    </>
  )
}
export default ThreeDSkeleton
